import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FileOpenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"file_open"}/>
}
